<script setup lang="ts">
import CatalogProductCard from '~/entities/catalog/products/content/CatalogProductCard.vue'
import useCatalogStore from '~/shared/store/modules/catalog'

const catalogStore = useCatalogStore()
</script>

<template>
  <div class="catalog-products">
    <CatalogProductCard
      v-for="product in catalogStore.catalog?.products"
      :key="`product_${product.id}`"
      :product="product"
    />
  </div>
</template>

<style lang="scss" scoped>
.catalog {
  &-products {
    display: grid;
    align-items: center;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 24px 8px;
    margin-top: 20px;
    @include md-breakpoint {
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 36px 16px;
      margin-top: 0;
    }
    @include sm-breakpoint {
      grid-template-columns: repeat(2, 1fr);
    }
    @include xs-breakpoint {
      grid-template-columns: 1fr;
    }
  }
}
</style>
